module.exports = __webpack_public_path__ + "static/media/NoNotifications.db5e8d4c.svg";